import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import SessionFacade from '@app/core/facades/session.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '218px';

@Component({
  selector: 'app-filter-session',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class SessionFilterComponent extends FilterComponent implements OnInit {
  public readonly width = SIZE;
  public readonly label = 'Session';

  constructor(private readonly _data: SessionFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateSessionFilteredId(value);
    this.valueChange.emit(new FilterChange(FilterType.Session, value));
  }

  ngOnInit() {
    this.options$ = (
      !!this.config.transform ? this.config.transform(this._data.sessionsFiltered$) : this._data.sessionsFiltered$
    ).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string | number }>) =>
        options.map((option) => ({ label: `${option.label}`, value: option.id }))
      )
    );

    this.initDefaultValues(this._data.sessionFilteredId$);
  }
}
